import classNames from 'clsx';
import React from 'react';
import { useLocation } from 'react-router';

import Link from '@swf/components/Link/Link';
import type { HgClubInfo } from '@swf/generated/types/api/v0/SwHomeGames';
import { Image } from '@swf/poker';

import styles from './SidebarNav.scss';

interface Props {
  club: HgClubInfo;
  clubsPath: string;
}

const SidebarNavClubItem = ({ club: { clubName, clubId, clubImage }, clubsPath }: Props) => {
  const { pathname } = useLocation();

  return (
    <Link
      href={`${clubsPath}/${clubId}/lobby`}
      className={classNames(styles.clubItem, {
        [styles.active]: pathname.includes(`${clubId}`)
      })}
    >
      <div className={styles.clubAvatar}>
        <Image className={styles.avatar} imageByteArray={clubImage} />
      </div>
      <div className={styles.clubName} title={clubName}>
        {clubName}
      </div>
    </Link>
  );
};

export default SidebarNavClubItem;
